var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", { staticClass: "loading_holder" }, [
        _c("div", { staticClass: "spinner_holder" }, [_c("c-spinner")], 1)
      ])
    : _c(
        "v-container",
        { staticClass: "container" },
        [
          _c(
            "v-layout",
            { attrs: { row: "", "mt-5": "", "justify-space-between": "" } },
            [
              _c("img", {
                attrs: {
                  src: _vm.selected_business.url,
                  height: "200px",
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("v-spacer")
            ],
            1
          ),
          _vm._v(" "),
          _c("v-layout", { attrs: { row: "", wrap: "", "mt-t": "" } }, [
            _c("p", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.selected_business.business_name))
            ])
          ]),
          _vm._v(" "),
          _c("v-layout", { attrs: { row: "" } }, [
            _c("p", { staticClass: "caption" }, [
              _vm._v("Email: " + _vm._s(_vm.selected_business.email))
            ])
          ]),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { column: "", "mb-1": "" } },
            [
              _c("v-flex", [
                _vm.show_facebook
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.selected_business.facebook_url,
                          target: "_blank"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "icon",
                          attrs: { src: "/static/images/facebook-logo.png" }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.show_instagram
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.selected_business.instagram_url,
                          target: "_blank"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "icon",
                          attrs: { src: "/static/images/instagram-logo.png" }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.show_tumblr
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.selected_business.tumblr_url,
                          target: "_blank"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "icon",
                          attrs: { src: "/static/images/tumblr-logo-2.png" }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-layout", { attrs: { row: "", wrap: "", "mt-5": "" } }, [
            _c("p", { staticClass: "body-1" }, [
              _c("b", [_vm._v("Publication: ")]),
              _vm._v(" " + _vm._s(_vm.selected_business.publication))
            ])
          ]),
          _vm._v(" "),
          _c("v-layout", { attrs: { row: "", wrap: "" } }, [
            _c("p", { staticClass: "body-1" }, [
              _c("b", [_vm._v("About: ")]),
              _vm._v(" " + _vm._s(_vm.selected_business.about))
            ])
          ]),
          _vm._v(" "),
          _c("v-layout", { attrs: { row: "", wrap: "" } }, [
            _c("p", { staticClass: "body-1" }, [
              _c("b", [_vm._v("Worth Knowing: ")]),
              _vm._v(" " + _vm._s(_vm.selected_business.worth_knowing))
            ])
          ]),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "divbottomline", attrs: { row: "", wrap: "" } },
            [
              _c("p", { staticClass: "body-1" }, [
                _c("b", [_vm._v("Additional Notes: ")]),
                _vm._v(" " + _vm._s(_vm.selected_business.additional_notes))
              ])
            ]
          ),
          _vm._v(" "),
          _c("v-layout", { attrs: { row: "", wrap: "", "mb-2": "" } }, [
            _c("p", { staticClass: "body-2 subheadingfont" }, [
              _vm._v("Statistics: N/A")
            ])
          ])
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e4ff34a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e4ff34a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/business.vue
// module id = null
// module chunks = 